import React, { useState, useEffect } from 'react';
import { CButton, CCard, CCardBody, CCol, CRow, CBadge, CInput, CLabel, CFormGroup, CProgress, CProgressBar } from '@coreui/react';
import ModalComments from 'src/reusable/modal-comment/ModalComments';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProjectDetails.css';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DateRangePickerInput, formatDateString } from 'src/reusable';

import { trackEvent, mixPanelEvents } from 'src/utils/mixpanel';
import { saveWeekly } from 'src/request/Reports';
import { GetProjectTimeline } from 'src/request/Projects';
import Lottie from 'react-lottie';
import animationData from '../../json/confetti2.json';
import $axios from 'src/utils/axios';
import { triggerProjectRefetch } from 'src/store/feature/project/projectSlice';

const HistoricalReports = (props) => {
  const [togglePhases, setTogglePhases] = useState([]);
  const [weeklyReport, setWeeklyReport] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState('');
  const [missedDatesCount, setMissedDatesCount] = useState(1);
  const [isModalCommentOpen, setIsModalCommentOpen] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [project_data, setProjectData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.id) {
      GetProjectTimeline(props.id)
        .then((res) => {
          if (res?.data?.project_data) {
            setProjectData(res.data.project_data);
          }
        })
        .catch((err) => {
          console.error('Error fetching project timeline:', err);
        });
    }

    const today = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(today.getDate() - 7);
    const startStr = formatDateString(oneWeekAgo);
    const endStr = formatDateString(today);
    getWeeklyData(`${startStr} - ${endStr}`);
  }, [props.id]);

  const openModalComment = (item) => {
    setReportData(item);
    setIsModalCommentOpen(true);
  };
  const closeModalComment = () => {
    setIsModalCommentOpen(false);
    setReportData([]);
  };

  const formatDateToMMDDYYYY = (dateInput) => {
    if (!dateInput) return '';
    const str = String(dateInput).trim();
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(str)) {
      return str;
    }
    const dateInstance = new Date(str);
    if (isNaN(dateInstance.getTime())) return str;
    const month = String(dateInstance.getMonth() + 1).padStart(2, '0');
    const day = String(dateInstance.getDate()).padStart(2, '0');
    const year = dateInstance.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const getWeeklyData = (dateRangeValue) => {
    setSelectedDateRange(dateRangeValue);
    let dateParts = dateRangeValue ? dateRangeValue.split(' - ') : [];
    const startDateFormatted = formatDateToMMDDYYYY(dateParts[0]);
    const endDateFormatted = formatDateToMMDDYYYY(dateParts[1] || dateParts[0]);

    setIsLoading(true);
    $axios
      .get(`report/historical-report/${props.id}?start=${startDateFormatted}&end=${endDateFormatted}`)
      .then((res) => {
        setWeeklyReport(res.data?.response?.data || []);
      })
      .catch((err) => {
        console.error('Error fetching weekly data:', err);
        setWeeklyReport([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveChanges = () => {
    let reportList = [...weeklyReport];
    let modifiedReports = [];

    for (let i = 0; i < reportList.length; i++) {
      let editedItems = [];
      reportList[i].date_range = selectedDateRange;
      reportList[i].save_type = 'HW';
      for (let j = 0; j < reportList[i].item.length; j++) {
        if (reportList[i].item[j].edited) {
          reportList[i].item[j].start_date = formatDateToMMDDYYYYString(reportList[i].item[j].start_date);
          reportList[i].item[j].end_date = formatDateToMMDDYYYYString(reportList[i].item[j].end_date);
          reportList[i].item[j].actual_start_date = formatDateToMMDDYYYYString(reportList[i].item[j].actual_start_date);
          reportList[i].item[j].actual_end_date = formatDateToMMDDYYYYString(reportList[i].item[j].actual_end_date);
          reportList[i].item[j].date_created = formatDateToMMDDYYYYString(reportList[i].item[j].date_created);
          editedItems.push(reportList[i].item[j]);
        }
      }

      if (editedItems.length > 0) {
        reportList[i].item = editedItems;
        modifiedReports.push(reportList[i]);
      }
    }

    if (modifiedReports.length > 0) {
      saveWeekly(props.id, modifiedReports).then((res) => {
        const mixpanelData = modifiedReports.map((section) => {
          const item = section.item?.[0] || {};

          return {
            work_item: item.work_item,
            psow_id: item.psow_id,
            sow_id: item.sow_id,
            start_date: item.start_date,
            end_date: item.end_date,
            actual_start_date: item.actual_start_date,
            actual_end_date: item.actual_end_date,
            project_id: props?.id,
            phase: section.phase,
            phase_id: section.phase_id,
            date_range: section.date_range,
            progress: section.progress,
          };
        });

        if (res.data.status == 200) {
          mixpanelData.forEach((item) => {
            trackEvent(mixPanelEvents.SAVE_HISTORICAL, {
              Source: 'Project - Reports - Historical Reports',
              ...item,
            });
          });

          Swal.fire({
            icon: 'success',
            title: 'Your work has been saved!',
            showConfirmButton: false,
            timer: 1500,
          });
          getWeeklyData(selectedDateRange);
          dispatch(triggerProjectRefetch(props?.id));
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.data.message,
            showConfirmButton: false,
            timer: 2500,
          });
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops..',
        text: 'No data to be save',
        confirmButtonColor: '#23303D',
      });
    }
  };

  const handleTogglePhase = (phaseId) => {
    const shownState = togglePhases.slice();
    const index = shownState.indexOf(phaseId);

    if (index >= 0) {
      shownState.splice(index, 1);
      setTogglePhases(shownState);
    } else {
      shownState.push(phaseId);
      setTogglePhases(shownState);
    }
  };

  const handleWorkItemChange = (e, dataIndex, itemIndex) => {
    let reportList = [...weeklyReport];
    reportList[dataIndex].item[itemIndex].work_item = e.target.value;
    setWeeklyReport(reportList);
  };

  const formatDateToMMDDYYYYString = (strDate) => {
    if (strDate) {
      let dateObj = new Date(strDate);
      let month = `${dateObj.getMonth() + 1}`.padStart(2, '0');
      let day = `${dateObj.getDate()}`.padStart(2, '0');
      let year = dateObj.getFullYear();
      return `${month}/${day}/${year}`;
    }

    return '';
  };

  const handleSowProgressChange = (value, itemIndex, dataIndex) => {
    const reportList = [...weeklyReport];
    reportList[dataIndex].item[itemIndex].status = value;
    reportList[dataIndex].item[itemIndex].edited = true;
    setWeeklyReport(reportList);
  };

  const handleStartDateChange = (value, itemIndex, dataIndex, category) => {
    const reportList = [...weeklyReport];
    if (category === 'target') {
      reportList[dataIndex].item[itemIndex].StartDate = value;
    } else if (category === 'actual') {
      reportList[dataIndex].item[itemIndex].actual_start_date = value;
    }
    reportList[dataIndex].item[itemIndex].edited = true;

    setWeeklyReport(reportList);
  };

  const handleEndDateChange = (value, itemIndex, dataIndex, category) => {
    const reportList = [...weeklyReport];
    if (category === 'target') {
      reportList[dataIndex].item[itemIndex].EndDate = value;
    } else if (category === 'actual') {
      reportList[dataIndex].item[itemIndex].actual_end_date = value;
    }

    reportList[dataIndex].item[itemIndex].edited = true;
    setWeeklyReport(reportList);
  };

  const ItemBadge = ({ underBudget, delayed, incomplete }) => {
    let badgeList = [];

    if (underBudget == 1) {
      badgeList.push(
        <CBadge key="budget" color="aimhi-success" className="badge-stats" style={{ marginTop: '15px', width: '150px' }}>
          WITHIN BUDGET
        </CBadge>,
      );
    } else {
      badgeList.push(
        <CBadge key="budget" color="aimhi-danger" className="badge-stats" style={{ marginTop: '15px', width: '150px' }}>
          OVER BUDGET
        </CBadge>,
      );
    }

    if (incomplete == 1) {
      badgeList.push(
        <CBadge key="status" color="aimhi-success" className="badge-stats" style={{ marginTop: '15px', width: '150px' }}>
          INCOMPLETE
        </CBadge>,
      );
    } else {
      if (delayed == 0) {
        badgeList.push(
          <CBadge key="status" color="aimhi-success" className="badge-stats" style={{ marginTop: '3px', width: '150px' }}>
            ON-TIME
          </CBadge>,
        );
      } else {
        badgeList.push(
          <CBadge key="status" color="aimhi-danger" className="badge-stats" style={{ marginTop: '3px', width: '150px' }}>
            DELAYED
          </CBadge>,
        );
      }
    }

    return badgeList;
  };

  const WeeklyCard = weeklyReport.map((data, index) => {
    let dataIndex = index;
    let isOnTime = true;
    const collapseCard = data.item.map((item, innerIndex) => {
      let itemStatus = item.status;
      let statusColor = '';
      if (itemStatus >= '100') {
        statusColor = 'green';
      } else if (itemStatus >= '1' && itemStatus <= '99') {
        statusColor = 'blue';
      } else if (itemStatus <= '0') {
        statusColor = 'gray';
      }

      if (item.actual_end_date > item.end_date) {
        isOnTime = false;
      } else {
        isOnTime = true;
      }

      return (
        <CCard className="shadow report-history-card" style={{ marginBottom: 0, marginLeft: '40px' }} key={innerIndex}>
          <CCardBody style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 15 }}>
            <CRow>
              <div className="float-left left-design-report"></div>
              {item.new == true ? (
                <CCol lg="4" style={{ padding: '10px' }}>
                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Work Item / Others</span>
                  <CInput value={item.work_item} onChange={(e) => handleWorkItemChange(e, dataIndex, innerIndex)} />
                </CCol>
              ) : (
                <CCol
                  lg="4"
                  style={{
                    padding: '10px',
                    display: 'flex',
                    alignItems: 'flex-end',
                    minHeight: '100%',
                  }}
                >
                  <span className="report-label">{item.work_item}</span>
                </CCol>
              )}

              <CCol lg="1.5" style={{ padding: '10px' }} id="Status">
                <CCol style={{ textAlign: 'center' }}>
                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Status</span>
                </CCol>
                <div className="progress-dropdown">
                  <div className="progress-dropdown" style={{ marginTop: '3px' }}>
                    <div style={{ position: 'relative' }}>
                      <CProgress style={{ height: '15px', width: '6rem' }}>
                        <div
                          id="editable"
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            color: 'black',
                            fontWeight: 'bold',
                          }}
                          onDoubleClick={(e) => {
                            if (item.is_editable) {
                              e.target.contentEditable = true;
                              e.target.innerText = e.target.innerText.replace('%', '');
                              e.target.focus();
                              e.target.style.paddingLeft = '1rem';
                              e.target.style.paddingRight = '1rem';
                            }
                          }}
                          onKeyDown={(e) => {
                            if (e.key == 'Enter') {
                              e.target.blur();
                            }
                          }}
                          onBlur={(e) => {
                            const newValue = parseFloat(e.target.innerText);
                            if (newValue > 100 || newValue < 0 || isNaN(newValue)) {
                              e.target.innerText = `${itemStatus}%`;
                            } else {
                              handleSowProgressChange(newValue, innerIndex, dataIndex);
                              itemStatus += newValue;
                              e.target.innerText = `${newValue}%`;
                            }
                            e.target.contentEditable = false;
                            e.target.style.paddingLeft = '8px';
                            e.target.style.paddingRight = '8px';
                          }}
                        >
                          <span>{`${itemStatus}%`}</span>
                        </div>
                        <CProgressBar value={itemStatus} className={statusColor + ' ' + 'select-design'} />
                      </CProgress>
                    </div>
                  </div>
                </div>
              </CCol>

              <CCol lg="4" className="text-center">
                <CRow>
                  <CCol className="text-center" id="Target/Actual Start">
                    <CRow style={{ paddingBottom: '10px' }}>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Target Start</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 reports"
                          placeholderText="mm/dd/yyyy"
                          value={item.start_date}
                          disabled
                          onChange={(value) => {
                            handleStartDateChange(value, innerIndex, dataIndex, 'target');
                          }}
                        />
                      </CCol>

                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Actual Start</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 border-black reports"
                          placeholderText="mm/dd/yyyy"
                          selected={item.actual_start_date ? new Date(item.actual_start_date) : null}
                          value={item.actual_start_date}
                          isClearable
                          onChange={(value) => {
                            handleStartDateChange(formatDateToMMDDYYYYString(value ? value.toLocaleDateString() : null), innerIndex, dataIndex, 'actual');
                          }}
                          disabled={!item.is_editable}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol className="text-center" id="Target/Actual End">
                    <CRow style={{ paddingBottom: '10px' }}>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Target End</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 reports"
                          placeholderText="mm/dd/yyyy"
                          value={item.end_date}
                          disabled
                          onChange={(value) => {
                            handleStartDateChange(value, innerIndex, dataIndex, 'target');
                          }}
                        />
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Actual End</span>
                      </CCol>
                      <CCol xs="12" sm="12" md="12" lg="12">
                        <DatePicker
                          className="border-2 border-black reports"
                          placeholderText="mm/dd/yyyy"
                          selected={item.actual_end_date ? new Date(item.actual_end_date) : null}
                          value={item.actual_end_date}
                          isClearable
                          onChange={(value) => {
                            handleEndDateChange(formatDateToMMDDYYYYString(value ? value.toLocaleDateString() : null), innerIndex, dataIndex, 'actual');
                          }}
                          disabled={!item.is_editable}
                        />
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>

              <CCol lg="2" style={{ padding: '10px' }} id="Comment/s">
                <CCol>
                  <span style={{ fontSize: '10px', fontWeight: 'bold' }}>Comment/s</span>
                </CCol>
                <CButton color="aimhi-textlight-neutral" size="sm" block onClick={() => openModalComment(item)}>
                  View
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      );
    });
    return (
      <CCol key={index} style={{ marginTop: '20px' }}>
        <CCard style={{ marginBottom: 0 }} className="shadow" onClick={() => handleTogglePhase(data.phase_id)}>
          <CCardBody>
            <CRow>
              <CCol lg="4">
                <span className="float-left circle-number">
                  <span>{index + 1}</span>
                </span>
                <div className="report-sow-label">{data.phase}</div>
              </CCol>

              <CCol lg="2" className="align-center" style={{ marginLeft: '30px' }}>
                <div className="circular-progress-size">
                  <CircularProgressbarWithChildren
                    className="circular-progress-size"
                    value={data.progress.toFixed(2)}
                    text={`${data.progress.toFixed(2)}%`}
                    styles={{
                      path: {
                        stroke: '#351D75',
                        strokeLinecap: 'butt',
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                        transformOrigin: 'center center',
                        circleRatio: '0',
                        strokeWidth: '-10',
                      },
                      trail: {
                        stroke: '#9c9c9c',
                        strokeLinecap: 'butt',
                        transform: 'rotate(0.25turn)',
                        transformOrigin: 'center center',
                        circleRatio: '0',
                        strokeWidth: '-10',
                      },
                      text: {
                        fill: '#23303D',
                        fontSize: '20px',
                        fontWeight: '700',
                      },
                      background: {
                        fill: '#54c2a2',
                      },
                    }}
                  />
                </div>
                <span className="status-label align-text-mobile">Progress</span>
              </CCol>

              <CCol lg="4" xl="2">
                <ItemBadge underBudget={data.under_budget} delayed={data.delayed} incomplete={data.incomplete} />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
        <CCol xl="12" style={{ padding: 0 }}>
          <div className={`transition-all duration-300 ease-in-out ${togglePhases.includes(data.phase_id) ? 'opacity-100' : 'max-h-0 overflow-hidden opacity-0'}`}>{collapseCard}</div>
        </CCol>
      </CCol>
    );
  });

  return (
    <>
      <CCol style={{ marginTop: '20px' }}>
        <CRow className="align-items-center">
          <CCol xl="8" lg="9" md="10">
            <CFormGroup row className="align-items-center mb-0">
              <CLabel className="col-auto mb-0" style={{ fontWeight: 'bold' }}>Date Range</CLabel>
              <CCol xl="6" lg="6" md="6">
                <DateRangePickerInput
                  value={selectedDateRange}
                  onChange={({ value: rangeStr }) => getWeeklyData(rangeStr)}
                  disableFutureDates={true}
                  defaultToWeekToday={true}
                  maxDays={7}
                  minDate={
                    project_data?.start_date
                      ? new Date(String(project_data.start_date).replace(/-/g, '/'))
                      : undefined
                  }
                />
              </CCol>
            </CFormGroup>
          </CCol>

          <CCol xl="4" className="text-right">
            <CButton color="aimhi-textlight-neutral" size="sm" onClick={saveChanges}>
              Save changes
            </CButton>
          </CCol>
        </CRow>

        {isLoading ? (
          <div className="text-center py-5 mt-4">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : weeklyReport && weeklyReport.length > 0 ? (
          WeeklyCard
        ) : (
          <CCard className="mt-4 text-center py-12 rounded-lg shadow-sm bg-white border border-gray-200">
            <CCardBody>
              <div className="py-4">
                <h4 className="text-xl font-bold mb-2 text-aimhi-textlight-neutral">It's empty here.</h4>
                <p className="text-sm text-gray-500 mb-0">
                  There's nothing to display at the moment for the selected date range {selectedDateRange ? `(${selectedDateRange})` : ''}.
                </p>
              </div>
            </CCardBody>
          </CCard>
        )}
        {isModalCommentOpen ? <ModalComments isModalOpen={isModalCommentOpen} reportData={reportData} onClose={closeModalComment} date={selectedDateRange} type={2} /> : null}
      </CCol>
    </>
  );
};

export default HistoricalReports;
